import styled from 'styled-components'

// components
import DefaultContainer from '../../components/DefaultContainer/DefaultContainer'

// styles
import { BREAKPOINTS, MY_RESERVATION_PAGE_MOBILE_BREAKPOINT } from '../../styles/constants'

export const PageContainer = styled(DefaultContainer)`
	position: relative;
`

export const MainContent = styled.div`
	@media (min-width: ${MY_RESERVATION_PAGE_MOBILE_BREAKPOINT}) {
		position: relative;
		display: flex;
		align-items: flex-start;
		gap: 40px;
	}
`

export const ReservationContainer = styled.div`
	@media (min-width: ${BREAKPOINTS.sm}) {
		flex: 1;
		min-width: 0;
	}
`

export const SidebarContainer = styled.div`
	display: none;

	@media (min-width: ${MY_RESERVATION_PAGE_MOBILE_BREAKPOINT}) {
		display: block;
		position: sticky;
		flex-shrink: 0;
		width: 360px;
		top: 16px;
	}

	@media (min-width: ${BREAKPOINTS.xl}) {
		width: 420px;
	}
`

export const PromoBannerLink = styled.a`
	text-decoration: none;
	display: block;
`

export const PromoBannerImage = styled.img`
	display: block;
	width: 100%;
	height: auto;
	aspect-ratio: 420 / 324;
`
